export default "__VITE_ASSET__a61b085f__"